module.exports = __webpack_public_path__ + "static/media/Artboard17.9b8735ae.png";